import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ConsultantLayout from '../commonlayouts/consultantlayout';
import Addbulkquestions from './addbulkquestions';
import { AddQuestions_BulkImport, GenerateContent, GetInterviewQuestions, GetJobRoles, GetTestTypes } from '../apiconstants/constants';
import { generatePath, Link, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useCountry } from '../contexts/countrycodecontext.js';
function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const GenerateAIQuestions = () => {
  let query = useQuery();
  const JobRole = query.get("JobRole");
  const [goal, setGoal] = useState('');
  const [prompts, setPrompts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const email = localStorage.getItem("email")
  const [questions, setQuestions] = useState([]);
  const [testTypes, setTestTypes] = useState([]);
  const [selectedTestType, setSelectedTestType] = useState("");
  const [jobRoles, setJobRoles] = useState([]);
    const { selectedCountry} = useCountry();

  useEffect(() => {
    fetchQuestions();
    fetchTestTypes();
    fetchJobRoles();
  }, [selectedCountry]);
  let Guid="";
  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid")
  const token = localStorage.getItem("jwtToken");
  const roleID = localStorage.getItem("roleID")
  
  if(roleID==3){
   Guid = employerGuid
  }
  else{
    Guid= guid
  }
  const fetchQuestions = async () => {
    setIsLoading(true);
    try {
      console.log("jobrole", JobRole)
     const response = await axios.get(GetInterviewQuestions.APIURL, {
  params: { UserGuid: Guid },
  headers: { Authorization: `Bearer ${token}` }
});

      setQuestions(response.data.filter((X) => X.jobRoleID == JobRole));
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching questions", error);
      setIsLoading(false);
    }
  };
  const fetchTestTypes = () => {
    const getTestTypesUrl = GetTestTypes.APIURL;
    axios.get(getTestTypesUrl,{headers: { Authorization: `Bearer ${token}` } }).then((response) => {
      setTestTypes(response.data);
    }).catch((error) => {
      console.error("Error fetching test types", error);
    });
  };

     const fetchJobRoles = async () => {
          try {
              const response = await axios.get(`${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`);
              setJobRoles(response.data);
          } catch (error) {
              console.error("Error fetching job roles", error);
          }
      };
  
  const getJobRole = (id) => {
    const role = jobRoles.find(role => role.jobRoleId == id);
    return role ? role.jobRole : 'Unknown';
};

const getTestType = (id) => {
    const type = testTypes.find(type => type.testTypeID == id);
    return type ? type.testType : 'Unknown';
}; 

const jobRoleName = getJobRole(JobRole);
const testTypeName = getTestType(selectedTestType);
  const generatePrompts = async () => {
    if (!selectedTestType) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please select test type',
        showConfirmButton: false,
        timer: 5000
      });
      return;
    }
    if (!goal.trim()) {
      setError('Goal cannot be empty.');
      return;
    }

    setIsLoading(true);
    setError('');

  const goalWithStaticText = `
${goal}.
Generate 10 scenario-based complex and moderate interview questions and answers in JSON format. 
Each item should be a JSON object with the following structure:

{
  "id": "1",
  "question": "your question text here",
  "answer": "your answer text here"
}

Return only a *JSON list* of such objects. Do not include any extra text, markdown, or formatting outside the JSON array.
`;

  try {
    const response = await axios.post(
     GenerateContent.APIURL,
      {
            prompt: goalWithStaticText,
      },
      { headers: {
        'Content-Type': 'application/json',
        'accept': '*/*',
        'Authorization': `Bearer ${token}` // Add the Authorization header       
         }}
    );

    const content = response.data?.response?.candidates[0]?.content?.parts[0]?.text || '';

    // Attempt to extract valid JSON from response
    let parsedData = [];
try {
  // Clean markdown-style code block from response (json ... )
  const cleanedJson = content
    .replace(/```json/i, '')
    .replace(/```/g, '')
    .trim();

  parsedData = JSON?.parse(cleanedJson);
} catch (jsonErr) {
  console.error("Failed to parse JSON from Gemini response:", jsonErr);
  return;
}


    const formattedPrompts = parsedData.map((item, index) => ({
      id: index,
      question: item.question?.trim() || 'No question provided',
      answer: item.answer?.trim() || 'No answer provided',
    }));

    setPrompts(formattedPrompts);
  } catch (err) {
    console.error('Error generating prompts:', err);
        if (err.response && err.response.status === 401) {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'Session expired! Please Login again',
              showConfirmButton: false,
              timer: 5000,
            }); 
            setTimeout(() => {
              window.location.href = "/Login"; // Redirect to login page
            }, 5000);
            return;
          }
    setError('Failed to generate prompts. Please try again later.');
  } finally {
    setIsLoading(false);
  }
};


  const handleSearchTestType = (e) => {
    console.log(e.target.value)
    setSelectedTestType(e.target.value);
  };

  const handleQuestionChange = (id, newQuestion) => {
    setPrompts((prevPrompts) =>
      prevPrompts?.map((prompt) =>
        prompt.id === id ? { ...prompt, question: newQuestion } : prompt
      )
    );
  };

  const handleAnswerChange = (id, newAnswer) => {
    setPrompts((prevPrompts) =>
      prevPrompts?.map((prompt) =>
        prompt.id === id ? { ...prompt, answer: newAnswer } : prompt
      )
    );
  };

  const submitUpdatedPrompts = async () => {
    try {

      const payload = prompts?.map((prompt) => ({
        question: prompt.question,
        answer: prompt.answer,
        jobRoleID: JobRole,
        testTypeID: selectedTestType,
        createdBy: email,
        userGuid: Guid,
        countryID:selectedCountry
      }));
      const response = await axios.post(
        AddQuestions_BulkImport.APIURL,
        payload,{ headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.message === 'Record created successfully') {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Added Successfully',
          showConfirmButton: false,
          timer: 5000
        });
        setGoal("");
        setPrompts([]);
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'something wrong!',
          showConfirmButton: false,
          timer: 5000
        });
      }

    } catch (err) {
      console.error('Error submitting prompts:', err);
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'something wrong!',
        showConfirmButton: false,
        timer: 5000
      });
    }
  };
  const handleDeleteQuestion = (id) => {
    setPrompts((prevPrompts) => 
      prevPrompts
        .filter((prompt) => prompt.id !== id)  // Remove the selected question
        .map((prompt, index) => ({ ...prompt, id: index }))  // Reindex the remaining questions
    );
  };
  

  return (
    <ConsultantLayout>
      <div className="container-fluid mt-4 pb-5">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Link to="/Employer/JobRoles">
            <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8 }} aria-hidden="true"></i>
          </Link>
          <h2 className="" style={{ color: "#00a7ac" }}>Generate AI Questions</h2>
        </div>
        <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Test Type</Tooltip>)}>
          <select
            className="form-control mb-4 mt-3"
            value={selectedTestType}
            onChange={handleSearchTestType}
            id="searchcss"
          >
            <option value="">Select Test Type</option>
            {testTypes.map((role) => (
              <option key={role.testTypeID} value={role.testTypeID}>
                {role.testType}
              </option>
            ))}
          </select>
        </OverlayTrigger>
        <textarea
          placeholder="Enter the goal for AI question generation..."
          value={goal}
          onChange={(e) => setGoal(e.target.value)}
          rows="4"
          style={{ width: '100%', marginBottom: '10px' }}
        />
        <button onClick={generatePrompts} disabled={isLoading || !goal} className="btn btn-primary pf-save mb-3 mr-3">
          {isLoading ? 'Generating...' : 'Generate Questions'}
        </button>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        {prompts?.map((prompt) => (
  <div key={prompt.id} style={{ marginBottom: '10px', padding: '10px' }}>
    <div>
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <strong>Question {prompt.id + 1}:</strong>
      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Delete Question</Tooltip>)}>

      <button 
      onClick={() => handleDeleteQuestion(prompt.id)} 
      style={{ background: "none", border: "none" }}
    >
  <i className="fa fa-trash" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i>

    </button>
    </OverlayTrigger>
    </div>
      <textarea
        value={prompt.question?.replace(/^\*\*Question\s\d+:\*\*/i, '').trim()}
        onChange={(e) => handleQuestionChange(prompt.id, e.target.value)}
        rows="2"
        style={{ width: '100%', marginBottom: '5px' }}
      />
    </div>
    <div>
      <strong>Answer:</strong>
      <textarea
        value={prompt.answer}
        onChange={(e) => handleAnswerChange(prompt.id, e.target.value)}
        rows="3"
        style={{ width: '100%' }}
      />
    </div>
 
    <hr />
  </div>
))}

        {prompts.length > 0 && (
          <button onClick={submitUpdatedPrompts} className="btn btn-primary mt-3">
            Submit
          </button>
        )}
      </div>
    </ConsultantLayout>
  );
};

export default GenerateAIQuestions;
